import { render, staticRenderFns } from "./c_ueditor_box.vue?vue&type=template&id=706289e1&scoped=true&"
import script from "./c_ueditor_box.vue?vue&type=script&lang=js&"
export * from "./c_ueditor_box.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "706289e1",
  null
  
)

export default component.exports